import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { getUserListings } from "@/lib/api/listings/userListingsApi";

/**
 * Custom hook to fetch listings belonging to the current user
 */
export const useUserListings = (status?: string) => {
  const { accessToken, isAuthenticated } = useAuth(); // Change 'token' to 'accessToken'

  return useQuery({
    queryKey: ["userListings", status], // Include status in queryKey
    queryFn: async () => {
      if (!accessToken) {
        // Use accessToken
        console.log("No accessToken found in useUserListings");
        return { listings: [], totalListings: 0 }; // Return empty object if no token
      }

      try {
        // Use the API function from userListingsApi, passing the status
        const response = await getUserListings(status);
        return response; // Return the entire response object
      } catch (error) {
        console.error("Error in useUserListings:", error);
        throw error;
      }
    },
    enabled: !!accessToken, // Only enable query if accessToken exists
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    meta: {
      onError: (error: unknown) => {
        console.error("Failed to fetch user listings:", error);
        toast.error("Failed to load your listings");
      },
    },
    select: (data) => data.listings, // Select only the listings array
  });
};
